var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tms-header" }, [
    _c(
      "div",
      {
        staticClass: "tms-header__box",
        class: { "tms-header__box-fullscreen": _vm.fullScreen },
      },
      [
        _c("div", { staticClass: "tms-header-top" }, [
          _c(
            "div",
            { staticClass: "tms-header-back-slot" },
            [
              _vm._t("back-button", function () {
                return [
                  _vm.needGoback
                    ? _c(
                        "span",
                        { staticClass: "back", on: { click: _vm._goback } },
                        [
                          _vm._v(
                            "\n            < " +
                              _vm._s(_vm.$t("back")) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.needRightTop
            ? _c(
                "div",
                { staticClass: "tms-header__right-top" },
                [
                  _vm._t("right-top", function () {
                    return [_c("span", [_vm._v("right-top")])]
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "main-title" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v("\n          " + _vm._s(_vm.title) + "\n          "),
                _vm.showDotOption
                  ? _c(
                      "dotted-dropdown",
                      { attrs: { id: "tenant-tms-header" } },
                      _vm._l(_vm.dotOption, function (item, index) {
                        return _c("li", { key: index }, [
                          _c(
                            "a",
                            {
                              staticClass: "dot-option-btn",
                              on: {
                                click: function () {
                                  return item.operate && _vm._operate(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.title) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c(
                "div",
                { staticClass: "tms-header-status-row" },
                [
                  _vm._t("status", function () {
                    return [
                      _vm.status
                        ? _c(
                            "div",
                            {
                              class: _vm.statusStyle,
                              on: {
                                click: function ($event) {
                                  return _vm.openLifecycleModal()
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("customStatusLabel")(_vm.status)
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                  _vm._v(" "),
                  _vm.helpFunc
                    ? _c(
                        "div",
                        {
                          staticClass: "help",
                          on: {
                            click: function () {
                              return _vm.helpFunc()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("workPermit.help")) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("status-detail"),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "Sticky",
                {
                  attrs: {
                    extendStickyClass: _vm.extendStickyClass,
                    zIndex: 110,
                    align: "right",
                    stickyTop: 40,
                    specifyWidth: "auto",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "button-groups" },
                    [
                      _vm._t("before-buttons"),
                      _vm._v(" "),
                      _vm._l(_vm.buttons, function (btn, index) {
                        return _c(
                          "button",
                          {
                            key: index,
                            class: ["btn", btn.cls],
                            attrs: { disabled: btn.disable },
                            on: {
                              click: function () {
                                return btn.func && _vm._btnOperation(btn)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(btn.title) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }